import { X } from 'lucide-react';

export default function Modal({ open, isOpen, title, onClose, children }) {
  if (!(open ?? isOpen)) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/70 p-3 backdrop-blur-[2px] sm:items-center sm:p-4">
      <div className="max-h-[90dvh] w-full max-w-3xl overflow-y-auto rounded-t-card border border-border bg-surface p-3 shadow-modal sm:rounded-card sm:p-4">
        <div className="sticky top-0 z-10 mb-3 flex items-center justify-between gap-3 border-b border-border bg-surface pb-3">
          <h3 className="min-w-0 font-display text-lg leading-tight sm:text-xl">{title}</h3>
          <button
            onClick={onClose}
            className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg text-zinc-400 transition-colors duration-150 hover:bg-surface2 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60"
            aria-label="Fechar"
          >
            <X size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

